<template lang="pug">
.render-item-pc
  .img-item-pc
    img(:src="item.banner[0]" v-if="item.banner && item.banner !== null && item.banner.length > 0")
    img(src="../../assets/Obee_Logo_140@2x.png" v-else)
    label.status(v-bind:class="[item.status == 1 ? 'active': '']")
      strong
      span(v-if="item.status == 1") Đang hoạt động
      span(v-else) Tạm ngưng 
    .clearfix
  .teacher-item-pc
    .item-title
      img(:src="item.icon" v-if="item.icon && item.icon.length")
      img(src="../../assets/images/faces/avt-default.png" v-else)
      span(@click="doListClasses(item.id)") {{ item.name }}
    .box-info
      .item-info
        .subject.inline-block
          img.icon(src="../../assets/images/faces/ic_khoilop@2x.png")
          span 
            abbr {{item.subject_name}}
        .grade.inline-block
          img.icon(src="../../assets/images/faces/Mask Group 97.svg")
          span 
            abbr {{lstGrades}}
      .member
        img.icon(src="../../assets/images/faces/ic_thanhvien@2x.png")
        span {{numberWithCommas(item.count)}} thành viên
      .box-function
        input(:value="url(item.site_id, item.name, item.id)" :id="'page_' + item.id" readonly="true")
        a.copy(@click.stop.prevent="doCopy('page_' + item.id)")
          img(src="../../assets/images/pc/ic_copy.svg")
          //- span.material-icons(@click.stop.prevent="doCopy('page_' + item.id)") file_copy
        ShareNetwork.share(network="facebook" :url="url(item.site_id, item.name, item.id)" :title="item.name" :description="item.description")
          img(src="../../assets/images/pc/ic_share.svg")
          //- span.material-icons share 
        a.edit(@click="doEdit(item.id)")
          img(src="../../assets/images/pc/ic_edit.svg")
      .clearfix
    .clearfix
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'

export default {
  components: {
    MdNotification
  },
  props: {
    item: Object,
    obj_id: Number
  },
  data() {
    return {
      lstGrades: ''
    }
  },
  mounted () {
    this.getGrades()
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    url(siteID, title, pcID) {
      let url = window.location.origin + '/' + this.$router.resolve({path: '/'}).href + 'landing/' + siteID + '/'
      let seoUrl = url + this.$mycontroller.doSanitizeTitle(title) + '-' + pcID
      return seoUrl
    },
    doCopy(pageID) {
      let textID = document.querySelector('#' + pageID)
      textID.select()
      try {
        var successful = document.execCommand('copy')
        if (successful) this.showNotification('Copy thành công', 'success', 'top', 'right', 2000)
        else this.showNotification('Không thể copy', 'warning', 'top', 'right', 2000)
      } catch (err) {
        this.showNotification('Không thể copy', 'warning', 'top', 'right', 2000)
      }
    },
    doEdit(pageID) {
      this.$router.push({name: 'general_edit', query: {id: pageID}})
    },
    doListClasses(pcID) {
      this.$router.push({name: 'classes', query: {id: pcID}})
    },
    getGrades() {
      this.$apollo.query({
        query: gql(graphql.GET_GRADE_TO_PC),
        variables: {
          pc_id: this.obj_id
        }
      }).then((response) => {
        let classes = response.data.classes
        this.convertOjectToString(classes)
      })
    },
    convertOjectToString (object) {
      if (object !== null) {
        let grades = []
        Object.keys(object).forEach(function(key) {
          grades.push(object[key].grade.name)
        })
        this.lstGrades = grades.join(', ').replace('["').replace('"]')
      }
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  created () {
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.box-content{
    .box-pc-create{
      &.render-list{
        .item-pc-list{
          .render-item-pc{ margin-bottom: 15px;position: relative; float: left;width: 100%;
            .img-item-pc{width: 200px;  height: 113px; position: relative;  float: left; margin-right: 15px;
              img{margin: auto; max-width: 100%; height: auto;display: block;width: auto; max-height: 100%;}
              label.status{position: absolute; background: #000000; height: 16px; line-height: 16px; padding: 0 5px; font-size: 10px; position: absolute;top:8px; left: 8px;margin: 0;
                &.active{
                  strong{background: #3A9F00;}
                  span{color: #3A9F00;}
                }
                strong{border-radius: 50%; height: 8px; width: 8px;background: #E0E0E0; display: inline-block;}
                span{letter-spacing: 0px;color: #E0E0E0; font-size: 10px;display: inline-block;margin-left: 5px;}
              }
            }
            .teacher-item-pc{ float: left; width: calc(100% - 215px);
              .item-title{min-height: 40px;cursor: pointer;
                img { max-width: 100%;height: 16px;width: 16px; margin-right: 10px; display: inline-flex; border-radius: 50%;}
                span {font-size: 15px; font-weight: bold; color: #343A40; text-align: left; width: calc(100% - 30px); display: inline-flex; }
              }
              .box-info {margin-top: 1px;
                .item-info{width: 100%; margin-bottom: 0px;
                  .inline-block{width: 50%; display: inline-block;
                    &.subject{
                      span{color: #3A9F00; display: inline-flex; width: calc(100% - 30px);font-size: 13px;
                        abbr{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
                      }
                    }
                    &.grade{
                      span{color: #D63131;display: inline-flex; width: calc(100% - 30px);font-size: 13px;
                        abbr{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
                      }
                    }
                  }
                }
                img.icon{max-width: 100%;height: 16px;width: 16px; margin-right: 10px;display: inline-flex;}
                .member{
                  span{font-size: 13px; color: #4B2D15; display: inline-flex;}
                }
                .box-function{margin-top: 5px;
                  input{display: inline-block; background: #E0E0E0 0% 0% no-repeat padding-box; height: 24px; width: calc(100% - 70px); border: 0 none;letter-spacing: 0px;color: #9B9B9B; font-size: 10px; padding: 0 10px; border-radius: 10px;}
                  a{display: inline-block; width: 16px; margin-left: 5px; color: #9B9B9B; cursor: pointer;
                    span{font-size: 18px;}
                  }
                }
              }
            }
          }
        }
      }
      .item-pc-title{text-align: left; font-size: 15px; font-weight: bold; font-family: Helvetica;letter-spacing: 0px;color: #343A40;text-transform: uppercase;}
      .item-pc-img{margin: 30px 0 60px 0;text-align: center;height: 150px; display: flex;justify-content: center;align-items: center;
        img{max-width: 100%; height: auto;}
      }
      .item-pc-bottom{text-align: center;
        span{display: block;text-align: center;font-size: 15px;letter-spacing: 0px;color: #333333;}
        .button{line-height: 48px; height: 48px; width: 328px;display: block; margin: 30px auto 0;background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px;border: 0 none;color: #23180A; font-size: 14px;}
      }
    }
}
@media (max-width: 1366px){
  
}
@media (max-width: 1024px){
  .box-content{ width: 75%;}
}
@media (max-width: 991px){
  
}
@media (max-width: 767px){
  .box-content{width: 100%;
    .box-pc-create{ 
      .item-pc-list{
        .render-item-pc{
          .img-item-pc{width: 100% !important; height: auto !important; float:  none !important; margin: 0 !important;}
          .teacher-item-pc{width: 100% !important; float: none !important;margin-top: 10px;}
        }
      }
      .item-pc-title{display: none;}
      .item-pc-img{margin: 20px 0;}
      .item-pc-bottom{
        span{display: initial;}
        button{width: 100%;}
      }
    }
  }
}
@media (max-width: 640px){
  .box-content{ width: 100%;
    .box-pc-create{
      .item-pc-list{
        .render-item-pc{
          .img-item-pc{width: 100% !important; height: auto !important; float:  none !important; margin: 0 !important;}
          .teacher-item-pc{width: 100% !important; float: none !important;margin-top: 10px;}
        }
      }
      .item-pc-title{display: none;}
      .item-pc-img{margin: 20px 0;}
      .item-pc-bottom{
        span{display: initial;}
        button{width: 100%;}
      }
    }
  }
}
@media (max-width: 560px){
  .box-content{width: 100%;
    .box-pc-create{
      .item-pc-list{
        .render-item-pc{
          .img-item-pc{width: 100% !important; height: auto !important; float: none !important; margin: 0 !important;}
          .teacher-item-pc{width: 100% !important; float: none !important;margin-top: 10px;}
        }
      }
      .item-pc-bottom{
        button{width: 100%;}
      }
    }
  }
}
@media (max-width: 320px){
  .box-content{width: 100%;
    .box-pc-create{
      .item-pc-title{font-size: 13px;}
      .button-plus{font-size: 11px!important;}
      .item-pc-list{
        .render-item-pc{
          .img-item-pc{width: 100% !important; height: auto !important; float: none !important; margin: 0 !important;}
          .teacher-item-pc{width: 100% !important; float: none !important;margin-top: 10px;}
        }
      }
      .item-pc-bottom{
        button{width: 100%;}
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// item.vue?55d56a5a